import httpClient from './httpClient';

const prefix = 'core'

export default {
    async reportCompanyExpense() {
            const { data } = await httpClient({ requiresAuth: true }).get(`/${prefix}/reportPart`);
            return data;
    },
}